export default "__VITE_ASSET__uK_dvapu__"